export default __webpack_public_path__ + "static/media/sorted.22f0a520.jpg";